<section class="faqs-cta">
    <div class="container">
        <h2 class="section-title">Wondering if your question is frequently asked?</h2>
        <a [routerLink]="['/'+ routesConstants.HOW_IT_WORKS_FAQS_NAVIGATION]" class="primary-btn">View FAQs</a>
    </div>
</section>
